<template>
    <div class="resetPassword xi">
        <nh-com></nh-com>
        <div class="banner">
            <div class="banner-wrap clearfix">
                <div class="banner-text">
                    <h3>个人中心</h3>
                    <p>当前位置：
                        <router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>个人中心</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="personal-content">
            <div class="personal-box clearfix">
                <div class="personal-left">
                    <hd-img></hd-img>
                </div>
                <div class="personal-right">
                    <div class="personal-right-tit patientheard">
                        <div> <i class="iconfont">&#xe62c;</i><span>合集视频<em>列表</em></span></div>
                        <div style="color:#1FB7A6;font-weight: bold;margin-left: 15px;cursor: pointer;" @click="goadd"><i
                                class="el-icon-plus"></i>发布</div>
                    </div>
                    <!-- <div class="patientheard">
                            <div><i class="iconfont">&#xe62c;</i><span>单视频<em>管理</em></span></div>
                            <div class="patientright">
                                
                            </div>
                        </div> -->
                    <!-- 患者列表 -->
                    <div class="patientBox">
                        <div class="patient" v-for="(item, index) in videoList" :key="index">
                            <div class="pList">
                                <div class="pListLeft">
                                    <div class="videobox" @click="goDetail(item)">
                                        <img :src="item.cover">
                                        <div class="videoicon">{{ item.durationResult }}</div>
                                    </div>
                                    <div>
                                        <div>
                                            <h2 style="color:#333333">{{ item.name }}</h2>
                                            <div style="color:#808080; padding: 10px 0 10px 0">
                                                <i class="el-icon-s-data" style="color:#1B9183">
                                                    <span
                                                        style="color:#808080; margin-left: 5px;">总销量：{{ item.totalSale }}</span>
                                                </i>
                                                <i class="el-icon-chat-dot-square" style="margin-left: 40px;color:#1B9183">
                                                    <span
                                                        style="color:#808080; margin-left: 5px;">评论数：{{ item.commentCount }}</span>
                                                </i>
                                                <i class="el-icon-star-on" style="margin-left: 40px;color:#1B9183">
                                                    <span
                                                        style="color:#808080; margin-left: 5px;">收藏数：{{ item.collectCount }}</span>
                                                </i>
                                                <div style="display: flex">
                                                    <div> {{ item.isCharge == true ? '收费' : '免费' }}</div>
                                                    <div v-if="item.isCharge == true" style=" margin-left: 15px;"> 正常价：
                                                        {{ item.userPrice }}元</div>
                                                    <div v-if="item.isCharge == true" style=" margin-left: 15px;"> 会员价：
                                                        {{ item.vipPrice }}元</div>
                                                </div>

                                            </div>
                                        </div>
                                        <div>
                                            <div style="color:#808080; display:flex; justify-content: space-between;">
                                                <div style="display:flex">
                                                    <div>权限：{{ item.limits == 0 ? '公开发布' : '私密发布' }}</div>
                                                    <div style=" margin-left: 40px;">分类：{{ item.videoCategory.name }}</div>
                                                </div>
                                                <div style=" margin-left: 40px;">
                                                    {{ item.addTime }}
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="right-btn flex-center flex-wrap">
                                    <el-tag @click="gotransactionRecords(item)">交易</el-tag>
                                    <el-tag type="success" @click="editvideo(item)">编辑</el-tag>
                                    <el-tag type="danger" @click="godelete(item)">删除</el-tag>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <ft-com></ft-com>
</div>
</template>

<script>







import ftCom from '../../components/footer'
import nhCom from "../../components/navheader";
import hdImg from "../../components/headerImg";
// import {patientMain} from "../../components/patienTmanagement/patienTmanagement";
import { videoMain } from "../../components/video/video";
export default {
    name: "resetPassword",
    components: {
        ftCom,
        nhCom,
        hdImg
    },
    data() {
        // var patient= new patientMain(this.TokenClient, this.Services.Authorization)
        var video = new videoMain(this.TokenClient, this.Services.Statics)
        return {
            // patientDomain:patient,
            videoDomain: video,
            labelPosition: 'right',
            resetPassword: {
                oldPwd: '',
                newPwd: '',
                confirmPwd: ''
            },
            uploader: null,
            file: '',
            patientType: 1,// 固定值
            organitionId: 0,// 固定值
            keyWord: ' ',
            pageIndex: 1,
            userInfo: {},
            patientList: [],
            visible: false,
            videoList: [],
            id: this.$route.query.videoId, //列表页id
        };
    },
    mounted() {
        this.getList()
    },
    methods: {
        gotransactionRecords(e) {
            this.$router.push({
                path: '/video/transactionRecords',
                query: {
                    Id: e.id
                }
            })
        },
        goDetail(e) {
            this.$router.push({
                path: './videoDetail',
                query: {
                    videoId: e.id
                }
            })
        },
        godelete(e) {
            this.$confirm('是否删除此视频?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let _this = this
                var params=`${e.id}/${e.aliyunVideoId}`
                _this.videoDomain.getDeleteVideo(params, function (data) {
                    _this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    _this.getList()
                }, function (error) {
                    // _this.$message.error('修改失败！旧密码不正确，请重新输入。');
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleCommand(command, e1) {
            console.log(command, e1)
        },
        goedit() {
            this.visible = true
        },
        gorecord(e) {
            this.$router.push({
                path: '/patienTmanagement/recordList',
                query: {
                    patientId: e.id
                }
            })
        },
        goraddecord(e) {
            this.$router.push({
                path: '/patienTmanagement/addRecord',
                query: {
                    patientId: e.id
                }
            })
        },
        goadd() {
            this.$router.push({
                path: '/video/addVideo',
                query: {
                    collectionId: this.id
                }
            })
        },
        editvideo(e) {
            this.$router.push({
                path: '/video/addVideo',
                query: {
                    videoId: e.id
                }
            })
        },
        getList() {
            var _this = this;
            _this.userInfo = this.$store.state.localData.userInfo

            let params = _this.id + '/-999/ /' + _this.pageIndex
            _this.videoDomain.GetCollectionVideo(params, function (data) {
                _this.videoList = data.data.results
                for (var i = 0; i < _this.videoList.length; i++) {
                    var f = _this.videoList[i].addTime.split('T')
                    _this.videoList[i].addTime = f[0] + ' ' + f[1].slice(0, 8)
                }

            }, function (error) {
                console.log(error)
            })
        }
    }
}
</script>

<style scoped>
@import "../../assets/css/footer.css";

.banner {
    width: 100%;
    height: 160px;
    background: url("../../assets/img/news_banner.jpg") center no-repeat;
}

.videobox {
    position: relative;
    width: 235px;
    height: 130px;
    border-radius: 8px;
    margin-right: 25px;
    cursor: pointer;
}

.videobox img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.videoicon {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #000000;
    opacity: 0.6;
    border-radius: 5px;
    text-align: center;
    color: #fff;
    /* padding: 5px 0; */
}

.patientheard {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 21px 0 15px 0;
    border-bottom: 1px dashed #CCCCCC;
}

.patientright {
    display: flex;
    align-items: center;
}

.patientBox {
    padding: 21px 42px;
    color: #808080
}

.patient {
    padding: 21px 0 15px 0;
    border-bottom: 1px dashed #CCCCCC;
}

.pList {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.right-btn{
    width:80px;
}
.right-btn /deep/ .el-tag{
    margin-bottom: 10px;
    cursor: pointer;
}

.pListLeft {
    display: flex;
    align-items: center;
}

.banner-wrap {
    position: relative;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
}

.banner-text {
    float: left;
}

.banner-text h3 {
    padding-top: 35px;
    font-size: 26px;
    font-weight: normal;
    color: #ffffff;
}

.banner-text p {
    font-size: 14px;
    color: #ffffff;
    margin-top: 20px;
}

.banner-text p a {
    color: #ffffff;
    font-size: 14px;
    margin: 0 5px;
}

/**/
.personal-content {
    background: #f7f7f7;
    padding: 40px 0;
}

.personal-box {
    width: 1200px;
    margin: 0 auto;
}

.personal-left {
    float: left;
}

.personal-right {
    float: right;
    width: 900px;
    background: #FFFFFF;
    box-sizing: border-box;
}

.personal-right-tit {
    border-bottom: 1px solid #e5e5e5;
    padding: 20px;
}

.personal-right-tit .iconfont {
    color: #04a290;
    font-size: 24px;
    margin-right: 5px;
}

.personal-right-tit span {
    display: inline-block;
    font-size: 24px;
    font-weight: 700;
    color: #333333;
}

.personal-right-tit span em {
    font-style: normal;
    color: #04a290;
}

.personal-right>form {
    padding: 30px 15px;
    width: 460px;
}</style>
<style>.personal-center {
    display: none;
}</style>
